export interface IDashboardState {
    categoriesPopularityPlot: IPopularCategory[]
    categoriesPopularityPlotLoading: boolean
    totalTicketsPlot: ITotalTickets[]
    totalTicketsPlotLoading: boolean
    clientTotalTicketsPlot: ITotalTickets[]
    clientTotalTicketsPlotLoading: boolean
    usersPerMonthPlot: ILineChart
    usersPerMonthPlotLoading: boolean
    payingUsersPerMonthPlot: ILineChart
    payingUsersPerMonthPlotLoading: boolean
    expensesPerMonthPlot: ILineChart
    expensesPerMonthPlotLoading: boolean
    ticketsBoughtPerMonthPlot: ILineChart
    voucherTicketsPerMonthPlotLoading: boolean
    entriesPerMonthPlot: ILineChart
    drawTicketsPerMonthPlotLoading: boolean
    wishPopularityPerVoucherCost: IWishPopularityPerVoucherCost[]
    wishPopularityPeVoucherCostLoading: boolean
    wishPopularityPerPointsAward: IWishPopularityPerPointsAward[]
    wishPopularityPerPointsAwardLoading: boolean
    wishPopularityPerPointsAwardForClient: IWishPopularityPerPointsAward[]
    wishPopularityPerPointsAwardForClientLoading: boolean
    usersCountPerGender: IUsersCountPerGender[]
    usersCountPerGenderLoading: boolean
    clientTickets: IClientTickets
    clientTicketsLoading: boolean
    clientTicketsPerWish: IClientTicketsPerWish[]
    clientTicketsPerWishLoading: boolean
    clientProfitPerMonthPlot: ILineChart
    clientProfitPerMonthPlotLoading: boolean
    adminProfitPerMonthPlot: ILineChart
    adminProfitPerMonthPlotLoading: boolean
}

export interface IPopularCategory {
    id: string
    name_en: string
    name_mk: string
    name_al: string
    percentage: string
    total_tickets_available: number
    total_tickets_bought: number

    [key: string]: any
}

export interface ITotalTickets {
    bought: number | null
    date: string
    total: number
}

interface IDataset {
    date: string
    count: number
}

export interface ILineChart {
    total: number | null
    total_new: number
    dataset: IDataset[]
}

export const initialLineChartState: ILineChart = {
    total: 0,
    total_new: 0,
    dataset: []
}

export interface IWishPopularityPerVoucherCost {
    total_tickets_bought: number
    cost_range: string
}

export interface IWishPopularityPerPointsAward {
    total_tickets_bought: number
    points_range: string
}

export interface IUsersCountPerGender {
    gender: string | null
    count: number
}

export interface IClientTickets {
    total_tickets_available: number
    total_tickets_purchased: number
    tickets_redeemed: number
    tickets_expired: number
}

export const initialClientTickets: IClientTickets = {
    total_tickets_available: 0,
    total_tickets_purchased: 0,
    tickets_redeemed: 0,
    tickets_expired: 0
}


export interface IClientTicketsPerWish {
    wish_id: string
    name_en: string
    name_mk: string
    name_al: string
    option_name_en: string | null
    option_name_mk: string | null
    option_name_al: string | null
    total_tickets_available: number
    total_tickets_purchased: number
    tickets_redeemed: number
    tickets_expired: number

    [key: string]: any
}
